module.exports = __webpack_public_path__ + "static/bailey-f5f9dabf6196c9bda0c7bfee238862fe.jpg";